import { createIcon } from '@chakra-ui/react';

export const PlusWhiteIcon = createIcon({
  displayName: 'PlusWhiteIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="12"
        // height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M3 6H9"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 9V3"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
